/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import Select from 'react-select';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const buildingTypeOptions = [
  {
    label: 'mieszkalny',
    value: 'mieszkalnego',
    state: 'buildingType',
  },
  {
    label: 'socjalny',
    value: 'socjalnego',
    state: 'buildingType',
  },
];

const holdingTypeOptions = [
  {
    label: 'jednoosobowe',
    value: 'jednoosobowe',
    state: 'holdingType',
  },
  {
    label: 'wieloosobowe',
    value: 'wieloosobowe',
    state: 'holdingType',
  },
];

const demolitionOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'demolition',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'demolition',
  },
];

const rebuildingOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'rebuilding',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'rebuilding',
  },
];

const conditionsOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'conditions',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'conditions',
  },
];

const disasterOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'disaster',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'disaster',
  },
];

const evictionOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'eviction',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'eviction',
  },
];

const InfoTypeDict = {
  personId: {
    label: 'Seria i nr dokumentu tożsamości:',
    editable: true,
  },
  pesel: {
    label: 'PESEL:',
    editable: true,
  },
  buildingType: {
    label: 'Rodzaj lokalu:',
    editable: true,
    type: 'Select',
    options: buildingTypeOptions,
  },
  justification: {
    label: 'Uzasadnienie prośby:',
    editable: true,
    type: 'textarea',
  },
  holdingType: {
    label: 'Wnioskodawca prowadzi gospodarstwo:',
    editable: true,
    type: 'Select',
    options: holdingTypeOptions,
  },
};

const registrationDict = {
  regDate: {
    label: 'W gminie zameldowany/a jestem na pobyt stały od dnia:',
    editable: true,
  },
  regAddress: {
    label: 'Adres zameldowania:',
    editable: true,
    type: 'textarea',
  },
};

const livingConditionsDict = {
  address: {
    label: 'Adres faktycznego miejsca zamieszkania wnioskodawcy:',
    editable: true,
    type: 'textarea',
  },
  owner: {
    label: 'Lokal, w którym faktycznie zamieszkuje wnioskodawca stanowi własność:',
    editable: true,
    type: 'textarea',
  },
  legalBase: {
    label: 'Wnioskodawca zamieszkuje w lokalu na podstawie:',
    editable: true,
    type: 'textarea',
  },
  peopleCount: {
    label: 'Ilość wszystkich osób zamieszkujących w lokalu wraz z wnioskodawcą:',
    editable: true,
  },
  roomCount: {
    label: 'Ilość pokoi:',
    editable: true,
  },
  roomArea: {
    label: 'Łączna powierzchnia użytkowa pokoi [m2]:',
    editable: true,
  },
  areaPerPerson: {
    label: 'Na jedna osobę zamieszkującą w lokalu przypada powierzchnia [m2]:',
    editable: true,
  },
  demolition: {
    label: 'Lokal przeznaczony jest do rozbiórki:',
    editable: true,
    type: 'Select',
    options: demolitionOptions,
  },
  conditions: {
    label: 'Lokal nie spełnia warunków przeznaczenia na pobyt ludzi:',
    editable: true,
    type: 'Select',
    options: conditionsOptions,
  },
  rebuilding: {
    label: 'Właściciel lokalu zamierza przebudować lokal na cele inne niż mieszkalne:',
    editable: true,
    type: 'Select',
    options: rebuildingOptions,
  },
  disaster: {
    label: 'Dotychczas zajmowany lokal wnioskodawca utracił w skutek klęski żywiołowej lub katastrofy budowlanej:',
    editable: true,
    type: 'Select',
    options: disasterOptions,
  },
  eviction: {
    label: 'Wnioskodawca otrzymał wyrok sądu o eksmisję z lokalu z prawem do przyznania lokalu socjalnego:',
    editable: true,
    type: 'Select',
    options: evictionOptions,
  },
};

const realEstateDict = {
  flat: {
    label: 'Mieszkanie (adres, powierzchnia w m², tytuł władania):',
    editable: true,
    type: 'textarea',
  },
  house: {
    label: 'Dom (adres, powierzchnia w m², tytuł władania):',
    editable: true,
    type: 'textarea',
  },
  parcels: {
    label: 'Place, działki (adres, powierzchnia w m², tytuł władania):',
    editable: true,
    type: 'textarea',
  },
  agricultural: {
    label: 'Nieruchomości rolne (rodzaj, liczba hektarów, w tym przeliczeniowych):',
    editable: true,
    type: 'textarea',
  },
  building: {
    label: 'Zabudowa (budynki, inna zabudowa, powierzchnia w m²):',
    editable: true,
    type: 'textarea',
  },
};

const movablePropertyDict = {
  cars: {
    label: 'Samochody, motocykle (marka, model, rok produkcji, wartość szacunkowa):',
    editable: true,
    type: 'textarea',
  },
  machines: {
    label: 'Maszyny (rodzaj, wartość szacunkowa):',
    editable: true,
    type: 'textarea',
  },
  otherMovables: {
    label: 'Inne (rodzaj, wartość szacunkowa):',
    editable: true,
    type: 'textarea',
  },
};

const resourcesDict = {
  money: {
    label: 'Pieniężne (oszczędności, papiery wartościowe itp. - podać wartość nominalną):',
    editable: true,
    type: 'textarea',
  },
  valualableObjects: {
    label: 'Przedmioty wartościowe (wartość szacunkowa):',
    editable: true,
    type: 'textarea',
  },
};

const incomeDict = {
  totalIncome: {
    label: 'Łączny dochód mojej rodziny za okres ostatnich 3 m-cy wynosi [zł]:',
    editable: true,
  },
  incomePerPerson: {
    label: 'Na jednego członka mojej rodziny przypada kwota w wysokości [zł/miesiąc]:',
    editable: true,
  },
};

const otherResourcesDict = {
  otherResources: {
    label: 'Wprowadź informacje:',
    editable: true,
    type: 'textarea',
  },
};

class NabycieLokaluMieszkalnego extends React.Component {
  state = {
    info: {
      buildingType: null,
      personId: null,
      pesel: null,
      justification: null,
      regDate: null,
      regAddress: null,
      address: null,
      owner: null,
      legalBase: null,
      peopleCount: null,
      roomCount: null,
      roomArea: null,
      areaPerPerson: null,
      demolition: null,
      conditions: null,
      rebuilding: null,
      disaster: null,
      eviction: null,
      flat: null,
      house: null,
      parcels: null,
      agricultural: null,
      building: null,
      cars: null,
      machines: null,
      otherMovables: null,
      money: null,
      valualableObjects: null,
      otherResources: null,
      holdingType: null,
      totalIncome: null,
      incomePerPerson: null,
    },
    listPeople: [{
      name: '',
      birthDate: '',
      relationshipLevel: '',
      income: '',
    }],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
  };

  validators = {
    buildingType: [v.NotSelected],
    personId: [v.NotNull],
    pesel: [v.NotNull, v.isNumber],
    justification: [v.NotNull],
    regDate: [v.NotNull, v.CheckDate],
    regAddress: [v.NotNull],
    address: [v.NotNull],
    owner: [v.NotNull],
    legalBase: [v.NotNull],
    peopleCount: [v.NotNull, v.isNumber],
    roomCount: [v.NotNull, v.isNumber],
    roomArea: [v.NotNull, v.isNumber],
    areaPerPerson: [v.NotNull, v.isNumber],
    demolition: [v.NotSelected],
    conditions: [v.NotSelected],
    rebuilding: [v.NotSelected],
    disaster: [v.NotSelected],
    eviction: [v.NotSelected],
    takingDateStart: [v.NotNull, v.CheckDate],
    takingDateEnd: [v.NotNull, v.CheckDate],
    deviceDateStart: [v.NotNull, v.CheckDate],
    deviceDateEnd: [v.NotNull, v.CheckDate],
    holdingType: [v.NotSelected],
    totalIncome: [v.NotNull, v.isNumber],
    incomePerPerson: [v.NotNull, v.isNumber],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentWillMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onHide = () => this.setState({ showError: false });

  addPerson = () => {
    this.setState({
      listPeople: [...this.state.listPeople, {
        name: '',
        birthDate: '',
        relationshipLevel: '',
        income: '',
      }],
    });
  }

  removePerson = (i, state) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list,
    });
  }

  onChangePerson = (e, state, elem, index) => {
    const arr = this.state[state];
    arr[index][elem] = e.target.value;

    this.setState({
      [state]: arr,
    },
    () => this.validate(state, elem),
    );
  }

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        personId: 'AAA 876900',
        pesel: '123456789',
        buildingType: 'mieszkalnego',
        justification: 'Uzasadnienie testowe',
        holdingType: 'wieloosobowe',
        regDate: '01-02-2020',
        regAddress: 'Adres test',
        address: 'Adres testowy',
        owner: 'Właściciel testowy',
        legalBase: 'Podstawa testowa',
        peopleCount: 2,
        roomCount: 2,
        roomArea: 30,
        areaPerPerson: 15,
        demolition: 'TAK',
        conditions: 'TAK',
        rebuilding: 'NIE',
        disaster: 'TAK',
        eviction: 'NIE',
        flat: 'Mieszkanie testowe',
        house: 'Dom Testowy',
        parcels: 'Działki testowe',
        agricultural: 'Nieruchomości testowe',
        building: 'Zabudowa testowa',
        cars: 'Fiat Cinquecento',
        machines: 'Maszyny testowe',
        otherMovables: 'inne',
        money: '5zł',
        valualableObjects: 'Przedmioty wartościowe',
        otherResources: 'Informacje testowe',
        totalIncome: '5000.00',
        incomePerPerson: '2500',
      },
      listPeople: [{
        name: 'Jan Kowalski',
        birthDate: '24-01-1980',
        relationshipLevel: 'wnioskodawca',
        income: '3000.0',
      }, {
        name: 'Grażyna Kowalska',
        birthDate: '12-12-1982',
        relationshipLevel: 'żona',
        income: '2000.0',
      }],
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: {},
          selectedParcels: {},
          info: this.state.info,
          listPeople: this.state.listPeople,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <DecisionContainer
          title={'1. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <DecisionContainer
          title={'2. Sytuacja rodzinna wnioskodawcy'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={incomeDict}
          onChange={e => this.onChange(e, 'info')}
        >
          <div className="row">
            <div className="col-sm-8">
              Moja rodzina składa się z niżej wymienionych osób:
            </div>
            <div className="col-sm-4">
              <button
                type="submit-lg"
                className={'btn btn-primary'}
                style={{ float: 'right', ...btnStyle }}
                onClick={() => this.addPerson()}
              >
                Dodaj członka rodziny
            </button>
            </div>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Lp.</th>
                <th scope="col">Imię i nazwisko</th>
                <th scope="col">Data urodzenia</th>
                <th scope="col">Stopień pokrewieństwa do wnioskodawcy </th>
                <th scope="col">Dochód* z ostatnich 3 miesięcy</th>
              </tr>
            </thead>
            <tbody>
              {this.state.listPeople.map((v, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.name}
                        placeholder="Imię i nazwisko..."
                        onChange={(e) => this.onChangePerson(e, 'listPeople', 'name', i)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.birthDate}
                        placeholder="Data urodzenia..."
                        onChange={(e) => this.onChangePerson(e, 'listPeople', 'birthDate', i)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.relationshipLevel}
                        placeholder="Stopień pokrewieństwa..."
                        onChange={(e) => this.onChangePerson(e, 'listPeople', 'relationshipLevel', i)} />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={v.income}
                        placeholder="Dochód..."
                        onChange={(e) => this.onChangePerson(e, 'listPeople', 'income', i)}
                      />
                    </td>
                    <td>
                      <button
                        type="submit-lg"
                        className={'btn btn-danger'}
                        style={{ btnStyle }}
                        onClick={() => this.removePerson(i, 'listPeople')}
                      >
                        Usuń
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="row">
            <div className="col-sm-12" style={{ textAlign: 'justify' }}>
            * Za dochód uważa się wszelkie przychody rodziny po odliczeniu kosztów ich uzyskania oraz po odliczeniu składek na ubezpieczenie emerytalne i rentowe oraz na ubezpieczenie chorobowe, określonych w przepisach o systemie ubezpieczeń społecznych,
            chyba, że zostały już zaliczone do kosztów uzyskania przychodu. Do dochodu nie wlicza się świadczeń pomocy materialnej dla uczniów, dodatków dla sierot zupełnych, jednorazowych zapomóg z tytułu urodzenia się dziecka, dodatku z tytułu urodzenia dziecka,
            pomocy w zakresie dożywiania, zasiłków pielęgnacyjnych, zasiłków okresowych z pomocy społecznej, jednorazowych świadczeń pieniężnych i świadczeń w naturze z pomocy społecznej, dodatku mieszkaniowego, dodatku energetycznego oraz zapomogi pieniężnej, o
            której mowa w przepisach o zapomodze pieniężnej dla niektórych emerytów, rencistów i osób pobierających świadczenie przedemerytalne albo zasiłek przedemerytalny w 2007 r.
            </div>
          </div>
        </DecisionContainer>
        <DecisionContainer
          title={'3. Informacja o zameldowaniu na pobyt stały'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={registrationDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'4. Sytuacja mieszkaniowa wnioskodawcy'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={livingConditionsDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        <h4 style={{ textAlign: 'left', marginLeft: '20px' }}>
          5. Stan majątkowy wnioskodawcy
        </h4>
        <DecisionContainer
          title={'Nieruchomości'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={realEstateDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'Ruchomości'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={movablePropertyDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'Posiadane zasoby'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={resourcesDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'Inne, dodatkowe informacje o stanie majątkowym'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={otherResourcesDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

NabycieLokaluMieszkalnego.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(NabycieLokaluMieszkalnego),
);



// WEBPACK FOOTER //
// src/routes/eservices/PrzydzialLokaluMieszkalnego.js